import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ROUTES } from '../../utils/constants';

const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Logo/Header */}
      <header className="p-6">
        <Link to={ROUTES.HOME} className="inline-flex items-center">
          <span className="text-2xl font-bold bg-gradient-to-r from-primary-400 to-secondary-400 bg-clip-text text-transparent">
            SpeedMeet.ai
          </span>
        </Link>
      </header>
      
      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center p-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-md"
        >
          {/* Glow elements for visual effect */}
          <div className="absolute left-1/4 top-1/4 w-64 h-64 bg-primary-500/20 rounded-full filter blur-[100px] -z-10" />
          <div className="absolute right-1/4 bottom-1/4 w-64 h-64 bg-secondary-500/20 rounded-full filter blur-[100px] -z-10" />
          
          {/* Content */}
          <div className="glass-card p-8 w-full relative overflow-hidden">
            <div className="relative z-10">
              <Outlet />
            </div>
            
            {/* Additional decorative background elements */}
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-primary-500/10 rounded-full" />
            <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-secondary-500/10 rounded-full" />
          </div>
        </motion.div>
      </div>
      
      {/* Footer */}
      <footer className="py-4 px-6 text-center text-white/50 text-sm">
        <p>© {new Date().getFullYear()} SpeedMeet.ai All rights reserved.</p>
      </footer>
    </div>
  );
};

export default AuthLayout;
